import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { IdentityAuthService } from "../_services/identity-auth.service";
import { Observable, defer, map, of } from "rxjs";
import { UserService } from "../_services/user.service";

@Injectable({ providedIn: 'root' })
// protects routes from unauthenticated users
export class AuthGuard {
  constructor(private router: Router, private userService: UserService) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    let hasRoles = route.data['roles'] as string[];
    if (hasRoles) {
      for (let role of hasRoles) {
        if (!this.userService.IsInRole(role)) {
          return of(false);
        }
      }
    }

    return this.isSignedIn();
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    let hasRoles = route.data['roles'] as string[];
    if (hasRoles) {
      for (let role of hasRoles) {
        if (!this.userService.IsInRole(role)) {
          return of(false);
        }
      }
    }

    return this.isSignedIn();
  }

  isSignedIn(): Observable<boolean> {
    let o = defer(async () => {
      let isSignedIn = await this.userService.isSignedIn;
      if (!isSignedIn) {
        // redirect to signin page
        this.router.navigate(['identity/signin']);
      }
      return isSignedIn;
    });
    return o;
  }
}
